import cn from 'classnames';

import headerStyles from './header.module.scss';

export enum BackgroundVariant {
  top = 'top',
  bottom = 'bottom',
}

interface IHeaderBackgroundProps {
  variant: BackgroundVariant,
  className?: string,
}

const HeaderBackground = ({ variant, className }: IHeaderBackgroundProps) => {
  return (
    <div className={ cn(
      {
        [headerStyles.top]: variant === BackgroundVariant.top,
        [headerStyles.bottom]: variant === BackgroundVariant.bottom,
      },
      className,
    ) }
    />
  );
};

export default HeaderBackground;
